<style lang="less" scoped>
    @import url("~@/lib/base.less");
    .set {
      width: 100%;
      height: 100vh;
      background-color: #f7f9fa;
      padding-top: .pxToRem(20) [];
      box-sizing: border-box;
      .line {
        background-color: #ffffff;
        padding: .pxToRem(30) [];
        justify-content: space-between;
        font-size: .pxToRem(30) [];
        font-weight: bold;
        color: rgba(0, 0, 0, 1);
        line-height: .pxToRem(30) [];
        &-left {
          flex-shrink: 0;
        }
      }
      .input {
        text-align: right;
        font-weight: 500;
      }
      .mar {
        margin-bottom: .pxToRem(20) [];
      }
      .button {
        width: .pxToRem(564) [];
        height: .pxToRem(100) [];
        background: rgba(255, 219, 41, 1);
        border-radius: .pxToRem(50) [];
        margin: 0 auto;
        margin-top: .pxToRem(40) [];
        text-align: center;
        line-height: .pxToRem(100) [];
        font-size: .pxToRem(32) [];
      }
    }
</style>

<template>
    <div class='page set'>
        <div class='line flex mar'>
            <span class='line-left'>设置密码</span>
            <input class='input'
                   type='text'
                   v-model="password"
                   placeholder='6~12位数字字母组合' /></div>
        <div class='button'
             @click="save">
            <span>保存</span>
        </div>
    </div>
</template>
<script>
    import { UPDATE_PASSWORD } from '@/api'
    export default {
        data() {
            return {
                password: '',
            }
        },
        watch: {
            password(val) {
            }
        },
        methods: {
            save() {
                const { password } = this;
                let regLength = /^[A-Za-z0-9]{6,12}$/g;
                let regLetter = /^(?=[a-zA-Z]*[0-9])(?=[0-9]*[a-zA-Z])[a-zA-Z0-9]{6,12}$/;
                if (!regLength.test(password)) {
                    this.$toast('请输入6~12位的密码');
                    return
                }
                else if (!regLetter.test(password)) {
                    this.$toast('请输入6~12位数字字母组合的密码');
                    return
                }
                this.$util.post(UPDATE_PASSWORD, {
                    password
                }).then(res => {
                    if (!res.success) {
                        this.$toast(res.message);
                    }
                    else {
                        this.$toast('修改成功');
                        setTimeout(() => {
                            this.$util.pageBack();
                        }, 1500);
                    }
                })
            }
        }
    }
</script>
